export default __webpack_public_path__ + "static/video-thumb-placeholder-1-e23622912006ec02d7632c21a54d87a0.jpg";